<template>
  <el-select v-model="innerValue" placeholder="全部" clearable @change="change">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
  </el-select>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      innerValue: this.value,
      options: [
        {
          value: '<500',
          label: '小于500',
        },
        {
          value: '>=500',
          label: '大于等于500',
        },
        {
          value: '>=1000',
          label: '大于等于1000',
        },
        {
          value: '>=5000',
          label: '大于等于5000',
        },
        {
          value: '>=10000',
          label: '大于等于10000',
        }
      ]
    }
  },
  watch: {
    value(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    change(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style></style>